export default function Header({ status, online }) {
  return (
    <div className="header">
      <div className="brand">Admin Dashboard</div>
      <div className={`status ${online ? "ok" : "fail"}`}>
        {status}
      </div>
    </div>
  );
}
